import { useEffect, useState } from "react";

import { AccountingActionEnum } from "@/features/chart-of-account-preferences";
import { apiClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

/**
 * Fetches the master COAs configured for the "Akun Penyesuaian"
 * (INVENTORY_ADJUSTMENT) accounting-action preference. These are the accounts a
 * user may pick as the adjustment account on a stock adjustment.
 */
export const useInventoryAdjustmentAccounts = () => {
  const { showSnackbar } = useSnackbar();
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const fetchAccounts = async () => {
      setLoading(true);
      try {
        const { data } = await apiClient.get("accounting-action-preferences", {
          params: { action: AccountingActionEnum.INVENTORY_ADJUSTMENT },
        });

        // Server already filters by action and returns rows ordered by
        // sort_order, so the first account is the configured default.
        const options = (data.data || [])
          .filter((item) => item.chartOfAccount)
          .map((item) => item.chartOfAccount);

        if (active) setAccounts(options);
      } catch (error) {
        if (active) {
          setAccounts([]);
          showSnackbar(getErrorMessage(error, "Gagal memuat akun penyesuaian"));
        }
      } finally {
        if (active) setLoading(false);
      }
    };

    fetchAccounts();

    return () => {
      active = false;
    };
  }, [showSnackbar]);

  return { accounts, loading };
};
